export enum WorkCategory {
  FeedbackAndRating = 'feedbackAndRating',
  FindBugsExploratory = 'findBugsExploratory',
  FindBugsTestPlan = 'findBugsTestPlan',
}
